import PageHeading from "../../../components/desktop/PageHeading";
export default function Dashboard() {
    return (
        <div>
            <PageHeading>User Desktop Dashboard</PageHeading>
        </div>
    );
}